import config from '../config';
import axios from 'axios';

export function getAboutInfo() {
  return axios.get(`${config.API_BASE_URL}/about/info`);
}

export function getQualificationList() {
  return axios.get(`${config.API_BASE_URL}/about/qualification`);
}

export function getHomeQualificationList() {
  return axios.get(`${config.API_BASE_URL}/website/index/qyzz`);
} 